const marketData = {
  title: 'How does this price compare?',
  districtTitle: 'Registered deals in this district',
  subtitle: 'Against sale deeds actually registered in {{district}}',
  subtitleNoDistrict: 'Against sale deeds actually registered here',

  band: {
    typical: 'Typical price',
    perM2: 'SAR / m²',
    halfOfDeals: 'Half of deals fell between {{low}} and {{high}}',
    mostDeals: 'Most deals fell between {{low}} and {{high}}',
    deeds_one: '1 registered deal',
    deeds_other: '{{count}} registered deals',
    window12: 'Last 12 months',
    window24: 'Last 24 months',
    period: '{{from}} to {{to}}',
    yourPrice: 'This listing',
    yourPriceShort: 'This listing',
    median: 'Typical',
    lowEnd: 'Lower',
    highEnd: 'Higher',
  },

  position: {
    within: 'Within the usual range',
    above: 'Above most registered deals',
    below: 'Below most registered deals',
    withinNote: 'This asking price sits inside the range half of the district’s deals registered at.',
    aboveNote: 'This asking price is above the range half of the district’s deals registered at. The property may have qualities the deed data cannot see.',
    belowNote: 'This asking price is below the range half of the district’s deals registered at.',
    noArea: 'Add the property area to compare price per m².',
  },

  rent: {
    title: 'Rent in this district',
    perYear: 'SAR a year',
    perM2Year: 'SAR / m² a year',
    contracts_one: '1 contract',
    contracts_other: '{{count}} contracts',
    types: {
      apartment: 'Apartment',
      studio: 'Studio',
      villa: 'Villa',
      floor: 'Floor',
      duplex: 'Duplex',
    },
    yoy: 'vs last year',
    freezeNotice: 'Note: Riyadh rents are subject to a freeze order.',
  },

  yieldCard: {
    title: 'Rental yield',
    gross: 'Gross yield',
    note: 'Gross, before costs and the 5% real-estate transaction tax',
    indicative: 'Indicative - small sample',
  },

  activity: {
    title: 'Market activity',
    lastFourQuarters: 'deals registered in the last four quarters',
    rankInCity: 'among the most active in {{city}}',
  },

  comps: {
    title: 'Nearby registered deals',
    subtitle: 'Real deeds registered in this district - not listings',
    date: 'Date',
    area: 'Area',
    price: 'Price',
    perM2: 'Per m²',
    areaUnit: 'm²',
    showAll: 'Show all deals',
    showLess: 'Show fewer',
  },

  trend: {
    title: 'Price trend',
    cityLevel: 'across {{city}}',
    twoYear: 'Change over two years',
    likeForLike: 'Like for like',
    likeForLikeNote: 'Measured on comparable sizes in comparable districts, so a shift in what sells does not look like a change in price.',
    up: 'Up',
    down: 'Down',
    flat: 'Broadly flat',
    noDistrictTrend: 'No district-level trend exists in the data - the figure above is the city’s.',
  },

  empty: {
    title: 'Not enough data',
    notEnoughDeals: 'This district has too few registered deals to show a reliable price range.',
    districtUnknown: 'We could not match this property to a district in the registry.',
    noSegment: 'Ministry of Justice records file villas and floors under “land”, so no price range can be shown for this type.',
    unavailable: 'Market data is unavailable right now.',
    rentOnly: 'Only rent data is available for this district.',
  },

  source: {
    label: 'Source',
    sale: 'Open sale-deed data - Ministry of Justice',
    rent: 'Rent indicators - Real Estate General Authority',
    updated: 'Updated {{date}}',
  },
  disclaimer: 'A statistical guide - not a property valuation',
  provisional: 'Provisional',
  provisionalNote: 'Since 2025-Q2 Riyadh transactions register through the Real Estate Registry and do not appear in full in the open data. Treat these figures as provisional.',
  matchedByCoordinates: 'Matched by location ({{km}} km)',

  loading: 'Loading market data…',
};

export default marketData;
